// @ts-nocheck
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { watchForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";
import { CountryModel, StateModel } from "@insite/client-framework/Types/ApiModels";
import { createAccount as createAccountApi } from "@store/Framework/Services/StoreAccountService";
import { StoreAccountModel } from "@store/Framework/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type userType = {
    email: string;
    firstName: string;
    lastName: string;
    warehouse: string;
    companyType: string;
    validation: {
        customerNumber: null;
        orderNumber: string;
    };
};

type billingShippingType = {
    firstName: string;
    lastName: string;
    company: string;
    address1: string;
    address2: string;
    country: CountryModel | undefined;
    state: StateModel | undefined;
    city: string;
    zip: string;
    phone: string;
    companyWebsite: string;
};

export interface StoreRequestAccessParameter {
    isExisting: boolean;
    user: userType;
    billing: billingShippingType;
    shipping: billingShippingType;
    isTermsAccepted: boolean;
    shippingSameAsBilling?: boolean;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    StoreRequestAccessParameter,
    StoreRequestAccessParameter,
    ServiceResult<StoreAccountModel>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await createAccountApi(props.apiParameter);
    watchForOtherTabSessionChange();
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const requestNewAccount = createHandlerChainRunner(chain, "RequestNewAccount");
export default requestNewAccount;
